import React, { useMemo, useState } from "react";
import { Box, Typography, Divider, Button, Stack, TextField } from "@mui/material";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useOutletContext } from "react-router-dom";
import {
  modifyAddedPdfData,
  modifyAddedPdfDataSequence,
  transformDataInObj,
  transformedOtherAction,
} from "../../Helpers";
import { esignToolApi } from "../../services/esignApi";

export default function Settings() {
  const { openSideBar } = useOutletContext();
  const { coordinates = [] } = useSelector((state) => state.pdfCoordinates || {});
  const { insertPdfData = {} } = useSelector((state) => state.insertPdf || {});
  const { deletedPageData = [], addedPageData = [] } = useSelector(
    (state) => state.pageModification || {}
  );

  const [coordinateName, setCoordinateName] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState("");

  const hasCoordinates = useMemo(() => coordinates.length > 0, [coordinates]);

  const buildTemplatePayload = async () => {
    const item = coordinates.find((coord) => coord.value === "" || !coord.value);
    if (item) {
      throw new Error(`You missed selecting a variable on page number ${item.pageNumber}.`);
    }

    const imageItem = coordinates.find(
      (coord) =>
        (coord.value === "imageVal" || coord.data_type === "image_type") && !coord.imageUrl
    );
    if (imageItem) {
      throw new Error(`You missed uploading the image on page number ${imageItem.pageNumber}.`);
    }

    const documentTemplate = await transformDataInObj(coordinates);
    const addedPdf = modifyAddedPdfData(insertPdfData);
    const addedPdfSequence = modifyAddedPdfDataSequence(insertPdfData);
    const otherActionData = transformedOtherAction(deletedPageData, addedPageData);

    return {
      coordinate_name: coordinateName.trim(),
      document_template: documentTemplate,
      other_actions: {
        single_page: otherActionData,
        multiple_pages: { insert: addedPdf },
        multiple_page_sequence: { insert: addedPdfSequence },
      },
    };
  };

  const handleSaveCoordinates = async () => {
    const trimmedName = coordinateName.trim();

    if (!trimmedName) {
      setError("Coordinates name is required.");
      return;
    }

    if (!hasCoordinates) {
      toast.warning("No coordinates available to save.");
      return;
    }

    try {
      setIsSaving(true);
      setError("");

      const payload = await buildTemplatePayload();
      const response = await esignToolApi.saveSignerCoordinates(payload);

      if (response?.status) {
        toast.success(response?.message);
        setCoordinateName("");
        return;
      }

      throw new Error(response?.message || "Failed to save signing coordinates.");
    } catch (saveError) {
      toast.error(saveError?.message || "Failed to save signing coordinates.");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    openSideBar && (
      <Stack sx={{ height: "100%", width: "80%" }}>
        <Box sx={{ height: "80px", display: "flex", alignItems: "center" }}>
          <Typography
            noWrap
            component="p"
            sx={{ fontSize: "20px", fontWeight: 600, lineHeight: "20px", color: "#1D1D1D", ml: 2 }}
          >
            Settings
          </Typography>
        </Box>
        <Divider sx={{ borderWidth: "1px" }} />
        <Box
          sx={{
            borderRadius: "12px",
            background: "#fff",
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            p: 2,
          }}
        >
          <Box
            sx={{
              border: "1px solid #CFCFCF",
              borderRadius: "20px",
              background: "#FFFFFF",
              maxWidth: "540px",
              width: "100%",
              p: 0,
            }}
          >
            <Box sx={{ background: "#F1F1F1", borderRadius: "19px 19px 0 0", textAlign: "left", padding: "20px 14px"}}>
              <Typography sx={{ fontSize: "16px", fontWeight: 500, color: "#000000" }}>
                Signinig Co-ordinates
              </Typography>
            </Box>
            <Divider />
            <Box sx={{ padding: "20px 14px", display: "flex", flexDirection: "column",}}>
              <Typography sx={{ fontSize: "16px", fontWeight: 500, color: "#000000", marginBottom: "12px", textAlign: "left" }}>
                Coordinates name
              </Typography>
              <Box>
                <TextField
                    placeholder="Enter coordinates name"
                    type="text"
                    variant="outlined"
                    fullWidth
                    value={coordinateName}
                    onChange={(event) => {
                    setCoordinateName(event.target.value);
                    if (error) {
                        setError("");
                    }
                    }}
                    error={!!error}
                    helperText={error}
                    sx={{
                    boxSizing: "border-box",
                    borderRadius: "10px",
                    backgroundColor: "#fff",
                    borderColor: "#C0C0C0",
                    borderWidth: "5px",
                    "& .MuiOutlinedInput-root": {
                        borderColor: "#C0C0C0",
                        backgroundColor: "none",
                        "&:hover fieldset": {
                        borderColor: "#C0C0C0",
                        },
                        "&.Mui-focused fieldset": {
                        borderColor: "#C0C0C0",
                        },
                    },
                    "& .MuiFormHelperText-root": {
                        color: "#FF6666",
                    },
                    }}
                    InputProps={{
                        sx: { 
                            borderRadius: "10px",
                            height: 46,
                            fontSize: "16px",
                            fontWeight: "500",
                            "& input::-ms-reveal, & input::-ms-clear": {
                                display: "none",
                            },
                        },
                    }}
                />
              </Box>
              {/* <TextField
                fullWidth
                placeholder="Enter coordinates name"
                value={coordinateName}
                onChange={(event) => {
                  setCoordinateName(event.target.value);
                  if (error) {
                    setError("");
                  }
                }}
                error={!!error}
                helperText={error}
                inputProps={{ 
                    sx: { 
                        borderRadius: "10px",
                        height: 48,
                        fontSize: "13px",
                        fontWeight: "400",
                        "& input::-ms-reveal, & input::-ms-clear": {
                            display: "none",
                        },
                    }, }}
                sx={{
                    boxSizing: "border-box",
                    borderRadius: "10px",
                    backgroundColor: "#fff",
                    borderColor: "#C0C0C0",
                    borderWidth: "5px",
                    "& .MuiOutlinedInput-root": {
                        borderColor: "#C0C0C0",
                        backgroundColor: "none",
                        "&:hover fieldset": {
                        borderColor: "#C0C0C0",
                        },
                        "&.Mui-focused fieldset": {
                        borderColor: "#C0C0C0",
                        },
                    },
                    "& .MuiFormHelperText-root": {
                        color: "#FF6666",
                    },
                }}
              /> */}
              <Button
                variant="contained"
                onClick={handleSaveCoordinates}
                disabled={isSaving}
                sx={{
                  mt: 2,
                  width: "120px",
                  height: 38,
                  color: "#185CB7",
                  background: "#FFFFFF",
                  textTransform: "none",
                  fontSize: "16px",
                  borderRadius: "10px",
                  border: "1px solid #185CB7",
                  boxShadow: "none",
                  fontWeight: 500,
                  "&:hover": {
                    background: "#FFFFFF",
                    boxShadow: "none",
                  },
                  "&.Mui-disabled": {
                    background: "#F3F7FD",
                    color: "#8AAFE3",
                    borderColor: "#8AAFE3",
                  },
                }}
              >
                {isSaving ? "Saving..." : "Save"}
              </Button>
            </Box>
          </Box>
        </Box>
      </Stack>
    )
  );
}
